import { FunctionComponent } from 'react';
import { MaybeLoanID } from 'src/common/types';
import { ServerSideModuleData } from '../../GetServerSideProps/utils/getServerSideModuleData';
import { useResourceCardState } from './useResourceCardState';
import { ResourceCard } from './ResourceCard';

export type WiredResourceCardProps = {
    loanID: MaybeLoanID;
    serverFetchedData: Pick<ServerSideModuleData, 'ResourceCard'>;
};

export const WiredResourceCard: FunctionComponent<WiredResourceCardProps> = ({ loanID, serverFetchedData }) => {
    const {
        isLoading,
        trackModalPrimaryCTAClick,
        trackOutsideModalClick,
        trackCloseButtonClick,
        trackPrimaryCTAClick,
        status,
        documentURL,
        downloadURL,
        sendToApplication,
        isFirstPartyExperience,
    } = useResourceCardState({ loanID, serverFetchedData });

    return (
        <ResourceCard
            isLoading={isLoading}
            onStartApplication={sendToApplication}
            isFirstPartyExperience={isFirstPartyExperience}
            trackModalPrimaryCTAClick={trackModalPrimaryCTAClick}
            trackOutsideModalClick={trackOutsideModalClick}
            trackCloseButtonClick={trackCloseButtonClick}
            trackPrimaryCTAClick={trackPrimaryCTAClick}
            status={status}
            documentURL={documentURL}
            downloadURL={downloadURL}
        />
    );
};
